import { Box } from "@mui/material";
import { TabPanel } from "../../controls";
import { TokensTabPage } from "./TokensTabPage";

export const HelpPage = () => {
  return (
    <Box>
      <TabPanel name="home" items={[
        { label: "TOKENS", children: <TokensTabPage /> },
      ]}  />
    </Box>
  );
};
